import React from "react";
import { withStyles, withTheme } from "@material-ui/core";
import ArrowNext from "@material-ui/icons/KeyboardArrowRight";
import TrailerLoadingZone from "./LoadingZone";
import NoFMRTZone from "./NoFMRTZone";
import { TotalBillDiff } from "./BillDiff";
import constant from "./constant";
import TruckCabinOptymized from "./TrailerCabin/TruckCabinOptymized";
import TruckCabinGateout from "./TrailerCabin/TruckCabinGateout";
import { compose } from "recompose";

const styles = (theme) => ({
  trailer: {
    minWidth: 310,
    minHeight: 600,
  },
  head: {
    height: 100,
    width: "60%",
    margin: "0 20%",
    border: `2px solid ${theme.AppBGColor}`,
    borderRadius: 4,
    textAlign: "center",
    padding: 16,
    color: theme.gridTextColor,
  },
  routeType: {
    fontSize: 10,
  },
  routeName: {
    fontSize: 20,
    fontWeight: 600,
  },
  body: {
    display: "grid",
    minHeight: 567,
    minWidth: 265,
    backgroundColor: theme.trailerBackgroundColor,
    padding: 8,
    borderRadius: 4,
    border: `1px solid ${theme.trailerBorderColor}`,
  },
  cardsFMRT: {
    gridGap: "8px",
    display: "grid",
    gridTemplateColumns: "48% 49%",
  },
  cardNoFMRT: {
    paddingTop: 8,
  },
  action: {
    color: theme.gridTextColor,
    cursor: "pointer",
    "&:hover": {
      color: theme.palette.primary.main,
    },
    "&$isActive": {
      color: theme.palette.primary.main,
    },
  },
  allBills: {
    fontSize: 20,
    fontWeight: 600,
    textAlign: "center",
    paddingTop: 8,
  },
  billDiff: {
    display: "flex",
    justifyContent: "space-between",
    color: theme.gridTextColor,
    cursor: "pointer",
    "& $missedBills, & $extraBills, & $matchedBills": {
      "&>span": {
        fontSize: 20,
        fontWeight: 600,
        paddingRight: 8,
      },
    },
  },
  missedBills: {
    padding: "4px 8px",
    "&>span": {
      color: theme.ErrorMessageColor,
    },
    "&:hover": {
      backgroundColor: theme.errorBGColor,
      color: "black",
    },
    "&$isActive": {
      backgroundColor: theme.errorBGColor,
    },
  },
  extraBills: {
    padding: "4px 8px",
    "&>span": {
      color: theme.trailerExtraBillsColor,
    },
    "&:hover": {
      backgroundColor: theme.warningBGColor,
      color: "black",
    },
    "&$isActive": {
      backgroundColor: theme.warningBGColor,
    },
  },
  matchedBills: {
    padding: "4px 8px",
    "&>span": {
      color: theme.palette.primary.main,
    },
    "&:hover": {
      backgroundColor: theme.infoBGColor,
      color: "black",
    },
    "&$isActive": {
      backgroundColor: theme.infoBGColor,
    },
  },
  icon: {
    verticalAlign: "middle",
  },
  isActive: {
    color: "black",
    borderRadius: 2,
  },
});

class Trailer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.loadingZoneDefaultProps = {
      billType: this.props.billType,
      showBillDetails: this.props.billType === constant.BILL_TYPE.ACTUAL,
      updateFilter: this.props.updateFilter,
    };
  }

  viewAllBillsForRoute = (event) => {
    event.stopPropagation();
    if (this.props.updateFilter) {
      const { routeType, filter } = this.props;
      const selectRoute =
        filter.routeType === routeType && !filter.proType && !filter.loadingZone
          ? null
          : routeType;
      this.props.updateFilter({
        loadingZone: null,
        proType: null,
        routeType: selectRoute,
      });
    }
  };

  viewRouteMissedBills = (event) => {
    event.stopPropagation();
    if (this.props.updateFilter) {
      const { routeType, filter } = this.props;
      const selectProType =
        filter.routeType === routeType &&
        filter.proType === constant.PRO_TYPE.MISSED
          ? null
          : constant.PRO_TYPE.MISSED;
      const selectRouteType = selectProType ? routeType : null;
      this.props.updateFilter({
        loadingZone: null,
        proType: selectProType,
        routeType: selectRouteType,
      });
    }
  };

  viewRouteExtraBills = (event) => {
    event.stopPropagation();
    if (this.props.updateFilter) {
      const { routeType, filter } = this.props;
      const selectProType =
        filter.routeType === routeType &&
        filter.proType === constant.PRO_TYPE.EXTRA
          ? null
          : constant.PRO_TYPE.EXTRA;
      const selectRouteType = selectProType ? routeType : null;
      this.props.updateFilter({
        loadingZone: null,
        proType: selectProType,
        routeType: selectRouteType,
      });
    }
  };

  viewRouteMatchedBills = (event) => {
    event.stopPropagation();
    if (this.props.updateFilter) {
      const { routeType, filter } = this.props;
      const selectProType =
        filter.routeType === routeType &&
        filter.proType === constant.PRO_TYPE.MATCHED
          ? null
          : constant.PRO_TYPE.MATCHED;
      const selectRouteType = selectProType ? routeType : null;
      this.props.updateFilter({
        loadingZone: null,
        proType: selectProType,
        routeType: selectRouteType,
      });
    }
  };

  isTotalFiltered = (filterProType) => {
    const { filter } = this.props;
    return (
      filter.routeType === this.props.routeType &&
      filter.proType === filterProType
    );
  };

  render() {
    const {
      classes,
      routeType,
      trailerData,
      filter,
      billType,
      theme,
    } = this.props;
    const { gridBGColor, HeaderDefaultTextColor, gridTextColor } = theme;
    const TruckCabin =
      routeType === constant.ROUTE_TYPE.ACTUAL
        ? TruckCabinGateout
        : TruckCabinOptymized;
    return (
      <div className={classes.trailer}>
        <TruckCabin
          route={trailerData.routeName || ""}
          time={trailerData.startTime || ""}
          background={gridBGColor}
          border={HeaderDefaultTextColor}
          color={gridTextColor}
        />
        <div className={classes.body}>
          <div className={classes.cardsFMRT}>
            <TrailerLoadingZone
              {...this.loadingZoneDefaultProps}
              zoneName={constant.ZONES_LABEL.FRONT}
              data={trailerData.zoneDetails.front}
              isFilteredZone={filter.loadingZone === constant.ZONES.FRONT}
              filteredProType={
                filter.loadingZone === constant.ZONES.FRONT
                  ? filter.proType
                  : null
              }
            />
            <TrailerLoadingZone
              {...this.loadingZoneDefaultProps}
              zoneName={constant.ZONES_LABEL.MIDDLE}
              data={trailerData.zoneDetails.middle}
              isFilteredZone={filter.loadingZone === constant.ZONES.MIDDLE}
              filteredProType={
                filter.loadingZone === constant.ZONES.MIDDLE
                  ? filter.proType
                  : null
              }
            />
            <TrailerLoadingZone
              {...this.loadingZoneDefaultProps}
              zoneName={constant.ZONES_LABEL.REAR}
              data={trailerData.zoneDetails.rear}
              isFilteredZone={filter.loadingZone === constant.ZONES.REAR}
              filteredProType={
                filter.loadingZone === constant.ZONES.REAR
                  ? filter.proType
                  : null
              }
            />
            <TrailerLoadingZone
              {...this.loadingZoneDefaultProps}
              zoneName={constant.ZONES_LABEL.TAIL}
              data={trailerData.zoneDetails.tail}
              isFilteredZone={filter.loadingZone === constant.ZONES.TAIL}
              filteredProType={
                filter.loadingZone === constant.ZONES.TAIL
                  ? filter.proType
                  : null
              }
            />
          </div>
          {trailerData.zoneDetails.noFMRT.totalBills &&
          routeType === constant.ROUTE_TYPE.ACTUAL ? (
            <div className={classes.cardNoFMRT}>
              <NoFMRTZone
                {...this.loadingZoneDefaultProps}
                zoneName={constant.ZONES.NOFMRT}
                data={trailerData.zoneDetails.noFMRT}
                isFilteredZone={filter.loadingZone === constant.ZONES.NOFMRT}
                filteredProType={
                  filter.loadingZone === constant.ZONES.NOFMRT
                    ? filter.proType
                    : null
                }
                routeType={routeType}
              />
            </div>
          ) : null}
        </div>
        <div
          className={`${classes.action} ${
            filter.routeType === routeType &&
            !filter.proType &&
            !filter.loadingZone
              ? classes.isActive
              : ""
          }`}
        >
          <div className={classes.allBills} onClick={this.viewAllBillsForRoute}>
            <span>
              View all {trailerData.details.totalBills} {billType}
            </span>
            <ArrowNext fontSize={"large"} classes={{ root: classes.icon }} />
          </div>
        </div>

        {routeType === constant.ROUTE_TYPE.ACTUAL && (
          <div className={classes.billDiff}>
            <TotalBillDiff
              billCount={trailerData.details.missedBills}
              className={`${classes.missedBills} ${
                this.isTotalFiltered(constant.PRO_TYPE.MISSED)
                  ? classes.isActive
                  : ""
              }`}
              onClick={this.viewRouteMissedBills}
            >
              Missed
            </TotalBillDiff>

            <TotalBillDiff
              billCount={trailerData.details.extraBills}
              className={`${classes.extraBills}  ${
                this.isTotalFiltered(constant.PRO_TYPE.EXTRA)
                  ? classes.isActive
                  : ""
              }`}
              onClick={this.viewRouteExtraBills}
            >
              Extra
            </TotalBillDiff>

            <TotalBillDiff
              billCount={trailerData.details.matchedBills}
              className={`${classes.matchedBills}  ${
                this.isTotalFiltered(constant.PRO_TYPE.MATCHED)
                  ? classes.isActive
                  : ""
              }`}
              onClick={this.viewRouteMatchedBills}
            >
              Matched
            </TotalBillDiff>
          </div>
        )}
      </div>
    );
  }
}

export default compose(withTheme(), withStyles(styles))(Trailer);
